























import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { sanitizeLinkUrl } from '@shared/helpers/sanitizeLinkUrl';
import { BaseFooter, UCContainer } from '@shared/ui';

import { BRAND_FULL_NAME, FOOTER_HEADINGS } from '~/constants';

import AppFooterMenuItem from './internal/AppFooterMenuItem.vue';
import AppFooterMenuItemSocialMedia from './internal/AppFooterMenuItemSocialMedia.vue';
import type { SimpleMenuLink, SocialMediaLink } from './types';

export default defineComponent({
  name: 'AppFooterView',
  components: {
    AppFooterMenuItemSocialMedia,
    AppFooterMenuItem,
    BaseFooter,
    UCContainer,
  },
  props: {
    mainMenuItems: {
      type: Array as PropType<SimpleMenuLink[]>,
      default: () => [],
    },
    helpSupportMenuItems: {
      type: Array as PropType<SimpleMenuLink[]>,
      default: () => [],
    },
    socialMediaMenuItems: {
      type: Array as PropType<SocialMediaLink[]>,
      default: () => [],
    },
    accountMenuItems: {
      type: Array as PropType<SimpleMenuLink[]>,
      default: () => [],
    },
    shopMenuItems: {
      type: Array as PropType<SimpleMenuLink[]>,
      default: () => [],
    },
  },
  setup() {
    const copyright =
      `© ${new Date().getFullYear()} ${BRAND_FULL_NAME}. All Rights Reserved.`.toUpperCase();

    const getLink = (link: SimpleMenuLink) => sanitizeLinkUrl(link.link_href?.cached_url);

    return {
      copyright,
      getLink,
      FOOTER_HEADINGS,
    };
  },
});
